module.exports = __webpack_public_path__ + "img/Prime_Rib_Box.6d26e930.jpg";